<template>
	<div class="selected">
    <div class="header">
      <h1 class="statistics">待处理订单：<span class="num" v-if="unreceived">{{unreceived}}</span><i class="el-icon-loading" v-else></i></h1>
      <search-input @searchFun="searchFun" :targetStatus="this.$route.params.status" :isUseTableSpi="true" :extraParams="{'packageProductionType':'THIRDPARTY'}" placeholder="请输入生产条码号"></search-input>
    </div>
		<data-analysised-form v-model="form" ref="child" @getResult="getResult" @updateLoading="updateLoading" slot="form" @updateTable="updateTable" @updateAllSize="updateAllSize" :isVendor="true"></data-analysised-form>
		<pt-sub-title :title="currentTitle">
      <el-button type="text" slot="line" style="margin-left:10px;" @click="showDialig = true">点击查看已勾选数据</el-button>
    </pt-sub-title>
		<checkbox-lot-detail-list packageType="THIRDPARTY" ref="tableList" class="checkboxList"  @updateSelectedData='updateSelectedData' :status="currentStatus" :show-fields="showFields"></checkbox-lot-detail-list>
    <selected-data-dialog :dialogVisible="showDialig" :showFields="showFields" :tableData="selectedOrder" @updateVisible="updateVisible"></selected-data-dialog>
	</div>
</template>
<script>
import searchInput from '../components/search-input'
import checkboxLotDetailList from '../components-with-data/checkbox-lot-detail-list'
import dataAnalysisedForm from '../components-with-data/pt-data-analysised-form.vue'
import selectedDataDialog from '../components-with-data/selected-data-dialog'
export default {
  name: 'process-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    batchNum: {
      type: String,
      required: false
    },
    quantity: {
      type: String,
      default: ''
    }
  },
  components: {
    checkboxLotDetailList,
    dataAnalysisedForm,
    searchInput,
    selectedDataDialog
  },
  data () {
    return {
      loading: false,
      searching: false,
      searchParams: { batch_number: this.batchNum, order_status: 'LAB_SAMPLES_RECEIVED' },
      serachValue: [],
      submitList: [],
      notificeRefresh: false,
      files: [],
      // activeName: '批量操作',
      selectedOrder: [],
      backToStatus: 'CREATED',
      // 全部数据个数
      allSize: null,
      activeName: '扫码方式',
      form: {},
      unreceived: this.quantity,
      currentStatus: this.$route.params.status,
      showFields: ['样本条码号', '受检人', '性别', '样本类型', '实验室检测平台', '检测套餐', '生产条码号'],
      showDialig: false
    }
  },
  computed: {
    currentTitle () {
      return '已勾选样本（' + this.selectedOrder.length + '/' + this.unreceived + '）'
    }
  },
  watch: {
    quantity (val, old) {
      this.unreceived = val
    }
  },
  methods: {
    searchFun (data) {
      this.$refs.tableList.searchData(data)
    },
    reload () {
      this.$refs.tableList.reload()
    },
    catchFocus (e) {
      document.querySelector('.scan-input').focus()
      this.mouseDown = false
    // this.enabledScan()
    },
    selectHandler (memberId) {
      for (let i = 0; i < this.serachValue.length; i++) {
        let item = this.serachValue[i]
        if (item.memberId === memberId) {
          this.submitList.push(this.serachValue.splice(i, 1)[0])
        }
      }
    },
    deleteHandler (memberId) {
      let index = this.submitList.findIndex(item => item.memberId === memberId)
      this.serachValue.push(this.submitList.splice(index, 1)[0])
    },

    visibleHandle (val) {
      this.notificeRefresh && this.$emit('refresh')
      this.$emit('update:dialogVisible', val)
    },
    close () {
      this.notificeRefresh && this.$emit('refresh')
      this.$emit('update:dialogVisible', false)
    },
    // 获取从子组件勾选的值
    updateSelectedData (val) {
      this.selectedOrder = val
    },
    // getAllSize (val) {
    //   this.unreceived = val
    // },
    getResult (response) {
    // this.unreceived = response.data.unreceived
      this.$emit('updateLoading', false)
      this.$refs.tableList.clearSelection()
    },
    updateLoading (val) {
      this.$emit('updateLoading', val)
    },
    selectedSubmit () {
      console.log('selectedSubmit')
      this.$refs.child.formValidate().then(() => {
        if (!this.selectedOrder.length) {
          this.$message.warning('请勾选样本！')
        // this.$confirm('您未勾选任何样本，点击确定则提交整个批次, 是否继续?', '提示', { type: 'warning' }).then(() => {
        //   // 执行整个批次的接口
        //   this.$emit('updateLoading', true)
        //   this.$refs.child.submitForm([], this.batchNum)
        // }).catch((ee) => {
        //   this.$message.warning('已取消操作!')
        // })
        } else {
        // 将扫描的执行接口
          this.$emit('updateLoading', true)
          let orderIds = this.selectedOrder.map(e => { return e.id })
          this.$refs.child.submitForm(orderIds)
        }
      })
    },
    updateAllSize (val) {
      this.selectedOrder = []
      this.$emit('updateAllSize', val)
    },
    updateTable (val) {
      this.selectedOrder = []
      this.$refs.tableList.reload()
    },
    updateVisible (val) {
      this.showDialig = val
    }
  }
}
</script>
<style lang="less">
.selected{
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
	.el-upload{
		width: 67%;
		vertical-align: middle;
		.el-button--small{
			width:100%;
		}
	}
}
</style>
